export default __webpack_public_path__ + "static/media/Transformer_02.cc9b9883.png";